/**
 * Pagination Event Handlers
 *
 * Handles pagination controls: page size selection, previous/next navigation, and search input
 *
 * @module eventHandlers/paginationHandlers
 */

import type { State } from '../types';

export interface PaginationElements {
  pageSize: HTMLSelectElement;
  prev: HTMLButtonElement;
  next: HTMLButtonElement;
  q: HTMLInputElement;
}

/**
 * Setup pagination event handlers
 *
 * @param els - DOM elements for pagination controls
 * @param state - Application state
 * @param render - Render function
 */
export function setupPaginationHandlers(
  els: PaginationElements,
  state: State,
  render: () => void
): void {
  // Page size selection
  els.pageSize.addEventListener('change', () => {
    state.pageSize = Number(els.pageSize.value) || 25;
    state.page = 1;
    render();
  });

  // Previous page
  els.prev.addEventListener('click', () => {
    state.page = Math.max(1, state.page - 1);
    render();
  });

  // Next page
  els.next.addEventListener('click', () => {
    state.page = state.page + 1;
    render();
  });

  // Search query input
  els.q.addEventListener('input', () => {
    state.q = els.q.value;
    state.page = 1;
    render();
  });
}
